var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      class: [_vm.namespace(), _vm.mdsNS("dialog-wrapper")]
    },
    [
      _c("div", { class: [_vm.mdsNS("overlay"), _vm.namespace("overlay")] }),
      _vm._v(" "),
      _c("div", { class: [_vm.namespace("container")].concat(_vm.skinCls) }, [
        _c(
          "div",
          {
            class: [
              _vm.mdsNS("dialog dialog--active"),
              _vm.namespace("active")
            ],
            attrs: { role: "dialog", "aria-describedby": _vm.id }
          },
          [
            !!_vm.title
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.namespace("title"),
                      _vm.mdsNS("dialog__message")
                    ]
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.title) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { class: _vm.mdsNS("dialog__message"), attrs: { id: _vm.id } },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.message) + "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _vm._t("default"),
            _vm._v(" "),
            _vm.isSingleButton
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.mdsNS("dialog__action-buttons"),
                      _vm.namespace("single-mode")
                    ]
                  },
                  [
                    _vm.hasResolve
                      ? _c(
                          "button",
                          {
                            class: _vm.mdsNS(
                              "button dialog__resolve-button button--primary"
                            ),
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.click("resolve", _vm.resolve)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.resolve.label) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e()
                  ]
                )
              : [
                  _vm.hasReject || _vm.hasCancel || _vm.hasResolve
                    ? _c(
                        "div",
                        { class: _vm.mdsNS("dialog__action-buttons") },
                        [
                          _vm.hasReject
                            ? _c(
                                "button",
                                {
                                  class: _vm.mdsNS(
                                    "button dialog__reject-button"
                                  ),
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      return _vm.click("reject", _vm.reject)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.reject.label) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.hasCancel && _vm.hasResolve
                            ? _c(
                                "div",
                                {
                                  class: _vm.mdsNS(
                                    "dialog__cancel-resolve-buttons-holder"
                                  )
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      class: _vm.mdsNS(
                                        "button dialog__cancel-button"
                                      ),
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.click("cancel", _vm.cancel)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.cancel.label) +
                                          "\n                        "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      class: _vm.mdsNS(
                                        "button dialog__resolve-button button--primary"
                                      ),
                                      attrs: {
                                        type: "button",
                                        disabled: _vm.resolve.isDisabled
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.click(
                                            "resolve",
                                            _vm.resolve
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.resolve.label) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : _vm._e()
                ],
            _vm._v(" "),
            _vm.hasCheckbox
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.mdsNS("form__field-group"),
                      _vm.namespace("checkbox")
                    ]
                  },
                  [
                    _c(
                      "label",
                      {
                        class: _vm.mdsNS("form__checkbox"),
                        attrs: { for: "dialog-checkbox" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checked,
                              expression: "checked"
                            }
                          ],
                          class: _vm.mdsNS("form__checkbox-input"),
                          attrs: { id: "dialog-checkbox", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.checked)
                              ? _vm._i(_vm.checked, null) > -1
                              : _vm.checked
                          },
                          on: {
                            change: function($event) {
                              var $$a = _vm.checked,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.checked = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.checked = $$c
                              }
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { class: _vm.mdsNS("form__checkbox-visible-wrap") },
                          [
                            _c(
                              "span",
                              { class: _vm.mdsNS("form__checkbox-visual") },
                              [
                                _c(
                                  "svg",
                                  {
                                    class: _vm.mdsNS(
                                      "icon form__checkbox-checked-icon"
                                    ),
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [
                                    _c("use", {
                                      attrs: { "xlink:href": "#check--s" }
                                    })
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "svg",
                                  {
                                    class: _vm.mdsNS(
                                      "icon form__checkbox-indeterminate-icon"
                                    ),
                                    attrs: { "aria-hidden": "true" }
                                  },
                                  [
                                    _c("use", {
                                      attrs: { "xlink:href": "#minus--s" }
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { class: _vm.mdsNS("form__checkbox-text") },
                              [
                                _vm._v(
                                  _vm._s(_vm.checkbox.label) +
                                    "\n                        "
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }